module.exports = __webpack_public_path__ + "img/CPV.75ee65a3.svg";